import { Component, Input } from '@angular/core';
import { COLLEGE_RECON_CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-circle-progress',
  templateUrl: './circle-progress.component.html',
  styleUrl: './circle-progress.component.scss'
})
export class CircleProgressComponent {
  progressColor!: string;
  @Input() percentage: any = 0;
  @Input() subtitle: string = 'percent';
  @Input() radius: number = 32;

  ngOnInit() {
    this.getProgressColor();
  }

  ngOnChanges() {
    this.getProgressColor();
  }

  getProgressColor() {
    this.progressColor = this.percentage > COLLEGE_RECON_CONSTANTS.progressBar.good ? 'green' : this.percentage > COLLEGE_RECON_CONSTANTS.progressBar.medium ? 'orange' : 'red'
  }
}
